import { render } from "./MessageArea.vue?vue&type=template&id=d1a90236&scoped=true"
import script from "./MessageArea.vue?vue&type=script&lang=js"
export * from "./MessageArea.vue?vue&type=script&lang=js"

import "./MessageArea.vue?vue&type=style&index=0&id=d1a90236&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a90236"]])

export default __exports__